import { NitroModules } from "react-native-nitro-modules";
var hybrid;
function fileSystemNative() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneFileSystem");
  return hybrid;
}
export {
  fileSystemNative
};
//# sourceMappingURL=hybrid.native.js.map
